import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export const generatePrintableContent = (
  homeownerDetails,
  roofMeasurements,
  selectedContractor,
  installationData,
  formatDate
) => {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>RoofBidder - Installation Order Summary</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: Arial, sans-serif; padding: 40px; color: #333; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 3px solid #f97316; padding-bottom: 20px; }
        .header h1 { color: #f97316; font-size: 28px; margin-bottom: 10px; }
        .header p { color: #666; font-size: 14px; }
        .section { margin-bottom: 30px; page-break-inside: avoid; }
        .section-title { background: #f97316; color: white; padding: 10px 15px; font-size: 18px; margin-bottom: 15px; }
        .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; }
        .info-item { padding: 10px 0; border-bottom: 1px solid #e5e7eb; }
        .info-label { color: #666; font-size: 14px; margin-bottom: 5px; }
        .info-value { color: #111; font-size: 16px; font-weight: 600; }
        .measurements-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 15px; margin-top: 15px; }
        .measurement-box { border: 2px solid #e5e7eb; padding: 15px; text-align: center; border-radius: 8px; }
        .measurement-label { color: #666; font-size: 12px; margin-bottom: 5px; }
        .measurement-value { color: #f97316; font-size: 20px; font-weight: bold; }
        .footer { margin-top: 50px; text-align: center; color: #666; font-size: 12px; border-top: 1px solid #e5e7eb; padding-top: 20px; }
        .price-highlight { background: #fef3c7; padding: 15px; border-radius: 8px; text-align: center; margin: 20px 0; }
        .price-highlight .amount { color: #059669; font-size: 32px; font-weight: bold; }
        @media print {
          body { padding: 20px; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>🏠 RoofBidder</h1>
        <p>Installation Order Summary & Measurements</p>
        <p style="margin-top: 10px; font-size: 12px;">Order Date: ${new Date().toLocaleDateString(
          'en-US',
          { year: 'numeric', month: 'long', day: 'numeric' }
        )}</p>
      </div>

      <!-- Homeowner Information -->
      <div class="section">
        <div class="section-title">Homeowner Information</div>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Name</div>
            <div class="info-value">${homeownerDetails.name}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Email</div>
            <div class="info-value">${homeownerDetails.email}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Phone</div>
            <div class="info-value">${homeownerDetails.phone}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Property Type</div>
            <div class="info-value">${homeownerDetails.propertyType}</div>
          </div>
        </div>
        <div class="info-item" style="margin-top: 15px;">
          <div class="info-label">Property Address</div>
          <div class="info-value">${homeownerDetails.address}</div>
        </div>
      </div>

      <!-- Roof Measurements -->
      <div class="section">
        <div class="section-title">Roof Measurements for Roofer</div>
        
        <div class="measurements-grid">
          <div class="measurement-box">
            <div class="measurement-label">Total Roof Area</div>
            <div class="measurement-value">${roofMeasurements.totalArea.toLocaleString()} sq ft</div>
          </div>
          <div class="measurement-box">
            <div class="measurement-label">Pitched Area</div>
            <div class="measurement-value">${roofMeasurements.pitchedArea.toLocaleString()} sq ft</div>
          </div>
          <div class="measurement-box">
            <div class="measurement-label">Flat Area</div>
            <div class="measurement-value">${roofMeasurements.flatArea.toLocaleString()} sq ft</div>
          </div>
        </div>

        <div style="margin-top: 20px; padding: 15px; background: #fef3c7; border-radius: 8px;">
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
            <div><strong>Roof Type:</strong> ${roofMeasurements.roofType}</div>
            <div><strong>Roof Pitch:</strong> ${roofMeasurements.pitch}</div>
          </div>
        </div>

        <div class="measurements-grid" style="margin-top: 20px;">
          <div class="measurement-box" style="border-color: #8b5cf6;">
            <div class="measurement-label">Starter Shingles</div>
            <div class="measurement-value" style="color: #8b5cf6;">${roofMeasurements.starter} ft</div>
          </div>
          <div class="measurement-box" style="border-color: #3b82f6;">
            <div class="measurement-label">Ridge Caps</div>
            <div class="measurement-value" style="color: #3b82f6;">${roofMeasurements.caps} ft</div>
          </div>
          <div class="measurement-box" style="border-color: #06b6d4;">
            <div class="measurement-label">Valley</div>
            <div class="measurement-value" style="color: #06b6d4;">${roofMeasurements.valley} ft</div>
          </div>
          <div class="measurement-box" style="border-color: #14b8a6;">
            <div class="measurement-label">Ridges</div>
            <div class="measurement-value" style="color: #14b8a6;">${roofMeasurements.ridges} ft</div>
          </div>
          <div class="measurement-box" style="border-color: #10b981;">
            <div class="measurement-label">Drip Edge</div>
            <div class="measurement-value" style="color: #10b981;">${roofMeasurements.dripEdge} ft</div>
          </div>
          <div class="measurement-box" style="border-color: #84cc16;">
            <div class="measurement-label">Perimeter</div>
            <div class="measurement-value" style="color: #84cc16;">${roofMeasurements.perimeter} ft</div>
          </div>
        </div>
      </div>

      <!-- Contractor Information -->
      <div class="section">
        <div class="section-title">Selected Contractor</div>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Company Name</div>
            <div class="info-value">${selectedContractor.contractor}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Contact Person</div>
            <div class="info-value">${selectedContractor.contactName}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Phone</div>
            <div class="info-value">${selectedContractor.phone}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Email</div>
            <div class="info-value">${selectedContractor.email}</div>
          </div>
        </div>
      </div>

      <!-- Project Details -->
      <div class="section">
        <div class="section-title">Project Details</div>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">Materials</div>
            <div class="info-value">${selectedContractor.selectedBid.materials}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Timeline</div>
            <div class="info-value">${selectedContractor.selectedBid.timeline}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Warranty</div>
            <div class="info-value">${selectedContractor.selectedBid.warranty}</div>
          </div>
          <div class="info-item">
            <div class="info-label">Preferred Date</div>
            <div class="info-value">${
              installationData.preferredDate
                ? formatDate(installationData.preferredDate)
                : 'To be scheduled'
            }</div>
          </div>
        </div>

        <div class="price-highlight">
          <div style="color: #666; font-size: 16px; margin-bottom: 5px;">Total Project Cost</div>
          <div class="amount">$${selectedContractor.selectedBid.price.toLocaleString()}</div>
        </div>
      </div>

      <!-- What's Included -->
      <div class="section">
        <div class="section-title">What's Included</div>
        <ul style="list-style: none; padding: 0;">
          ${selectedContractor.selectedBid.included
            .map(
              (item) => `
            <li style="padding: 8px 0; border-bottom: 1px solid #e5e7eb;">
              ✓ ${item}
            </li>
          `
            )
            .join('')}
        </ul>
      </div>

      <div class="footer">
        <p><strong>RoofBidder</strong> - Your trusted roofing partner</p>
        <p style="margin-top: 5px;">This document serves as a comprehensive summary of your roofing project</p>
        <p style="margin-top: 10px; font-size: 10px;">Generated on ${new Date().toLocaleString()}</p>
      </div>
    </body>
    </html>
  `;
};

export const generatePDF = ({
  homeownerDetails,
  roofMeasurements,
  selectedContractor,
  installationData,
  formatDate,
}) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  
  // Header
  doc.setTextColor(249, 115, 22); // Orange #f97316
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.text("RoofBidder", 14, 20);
  
  doc.setTextColor(100);
  doc.setFontSize(12);
  doc.setFont("helvetica", "normal");
  doc.text("Installation Order Summary", 14, 28);
  doc.text(`Date: ${new Date().toLocaleDateString()}`, 14, 34);

  let yPos = 45;

  // Homeowner Details
  doc.setFillColor(249, 115, 22);
  doc.rect(14, yPos, pageWidth - 28, 8, "F");
  doc.setTextColor(255);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Homeowner Information", 16, yPos + 5.5);
  
  yPos += 15;
  doc.setTextColor(0);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  
  const homeownerData = [
    ["Name", homeownerDetails.name, "Email", homeownerDetails.email],
    ["Phone", homeownerDetails.phone, "Property Type", homeownerDetails.propertyType],
    ["Address", homeownerDetails.address, "", ""]
  ];
  
  autoTable(doc, {
    startY: yPos,
    head: [],
    body: homeownerData,
    theme: 'plain',
    styles: { fontSize: 10, cellPadding: 2 },
    columnStyles: { 0: { fontStyle: 'bold', width: 30 }, 2: { fontStyle: 'bold', width: 30 } },
    margin: { left: 14, right: 14 }
  });
  
  yPos = doc.lastAutoTable.finalY + 10;

  // Roof Measurements
  doc.setFillColor(249, 115, 22);
  doc.rect(14, yPos, pageWidth - 28, 8, "F");
  doc.setTextColor(255);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Roof Measurements", 16, yPos + 5.5);
  
  yPos += 15;
  
  const measurementsData = [
    ["Total Area", `${roofMeasurements.totalArea.toLocaleString()} sq ft`, "Pitched Area", `${roofMeasurements.pitchedArea.toLocaleString()} sq ft`],
    ["Flat Area", `${roofMeasurements.flatArea.toLocaleString()} sq ft`, "Roof Type", roofMeasurements.roofType],
    ["Pitch", roofMeasurements.pitch, "Perimeter", `${roofMeasurements.perimeter} ft`]
  ];

  autoTable(doc, {
    startY: yPos,
    head: [],
    body: measurementsData,
    theme: 'grid',
    styles: { fontSize: 10, cellPadding: 3 },
    headStyles: { fillColor: [240, 240, 240], textColor: 50 },
    columnStyles: { 0: { fontStyle: 'bold', width: 40 }, 2: { fontStyle: 'bold', width: 40 } },
    margin: { left: 14, right: 14 }
  });

  yPos = doc.lastAutoTable.finalY + 10;

  // Contractor Info
  doc.setFillColor(249, 115, 22);
  doc.rect(14, yPos, pageWidth - 28, 8, "F");
  doc.setTextColor(255);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Selected Contractor", 16, yPos + 5.5);
  
  yPos += 15;
  
  const contractorData = [
    ["Company", selectedContractor.contractor],
    ["Contact", selectedContractor.contactName],
    ["Phone", selectedContractor.phone],
    ["Email", selectedContractor.email]
  ];

  autoTable(doc, {
    startY: yPos,
    head: [],
    body: contractorData,
    theme: 'plain',
    styles: { fontSize: 10, cellPadding: 2 },
    columnStyles: { 0: { fontStyle: 'bold', width: 40 } },
    margin: { left: 14, right: 14 }
  });

  yPos = doc.lastAutoTable.finalY + 10;

  // Project Details
  doc.setFillColor(249, 115, 22);
  doc.rect(14, yPos, pageWidth - 28, 8, "F");
  doc.setTextColor(255);
  doc.setFontSize(11);
  doc.setFont("helvetica", "bold");
  doc.text("Project Details", 16, yPos + 5.5);
  
  yPos += 15;
  
  const projectData = [
    ["Materials", selectedContractor.selectedBid.materials],
    ["Timeline", selectedContractor.selectedBid.timeline],
    ["Warranty", selectedContractor.selectedBid.warranty],
    ["Preferred Date", installationData.preferredDate ? formatDate(installationData.preferredDate) : 'To be scheduled'],
    ["Total Cost", `$${selectedContractor.selectedBid.price.toLocaleString()}`]
  ];

  autoTable(doc, {
    startY: yPos,
    head: [],
    body: projectData,
    theme: 'striped',
    styles: { fontSize: 10, cellPadding: 3 },
    columnStyles: { 0: { fontStyle: 'bold', width: 40 } },
    margin: { left: 14, right: 14 }
  });
  
  return doc;
};
